import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import classnames from 'classnames'

import { giftSubscriptionDispatchers as mergeSelector } from 'reduxModules/subscriptions/dispatchers'
import { authInfoReselector as stateSelector } from 'reduxModules/auth/selectors'

import subscriptionPlans from '../../SubscriptionPlans/fixturePlans'
import '../../generic/RenderedField/styles.css'
import './styles.css'

const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i

export function GiftSubscription({ onSubmit, subscription = null }) {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm()

  const subscriptionType = () => {
    const planIds = subscriptionPlans.map((sub) => sub.id)
    if (planIds.includes(subscription.planId))
      return subscription.planId === 4 ? 'Year' : 'Month'
    return 'subscription'
  }

  return (
    <div id="GiftSubscription" className="account-section">
      <h3 className="account-section__title">Gift a Subscription</h3>
      <div className="gift-subscription-wrapper">
        <div className="gift-subscription-box">
          <div className="subheading">
            Congrats! You are able to gift (1) {subscriptionType()} of the {subscription.plan} subscription
          </div>
          <form id="GiftSubscriptionForm" onSubmit={handleSubmit(onSubmit)}>
            <div className={classnames('field', { '-error': errors.gifterName })}>
              <div className="field-container">
                <input
                  {...register('gifterName', {
                    required: 'This field is required.'
                  })}
                  type="text"
                  placeholder="Your Name"
                  aria-label="Your Name"
                />
                <span
                  className={`field__error${!errors.gifterName ? ' field__error--hidden' : ''}`}
                  role="alert"
                >
                  {errors.gifterName?.message}
                </span>
              </div>
            </div>
            <div className="send-text">Send subscription to: </div>
            <div className="input-names">
              <div className={classnames('field', { '-error': errors.firstName })}>
                <div className="field-container">
                  <input
                    {...register('firstName', {
                      required: 'This field is required.'
                    })}
                    type="text"
                    placeholder="First Name"
                    aria-label="First Name"
                  />
                  <span
                    className={`field__error${!errors.firstName ? ' field__error--hidden' : ''}`}
                    role="alert"
                  >
                    {errors.firstName?.message}
                  </span>
                </div>
              </div>
              <div className={classnames('field', { '-error': errors.lastName })}>
                <div className="field-container">
                  <input
                    {...register('lastName', {
                      required: 'This field is required.'
                    })}
                    type="text"
                    placeholder="Last Name"
                    aria-label="Last Name"
                  />
                  <span
                    className={`field__error${!errors.lastName ? ' field__error--hidden' : ''}`}
                    role="alert"
                  >
                    {errors.lastName?.message}
                  </span>
                </div>
              </div>
            </div>
            <div className={classnames('field', { '-error': errors.email })}>
              <div className="field-container">
                <input
                  {...register('email', {
                    required: 'This field is required.',
                    pattern: {
                      value: EMAIL_PATTERN,
                      message: 'Invalid email address.'
                    }
                  })}
                  type="email"
                  placeholder="Email"
                  aria-label="Email"
                />
                <span
                  className={`field__error${!errors.email ? ' field__error--hidden' : ''}`}
                  role="alert"
                >
                  {errors.email?.message}
                </span>
              </div>
            </div>
            <textarea
              {...register('message')}
              placeholder="Message"
              aria-label="Message"
            />
            <button type="submit" className="btn -wide submit-btn">
              Send Gift
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

GiftSubscription.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  subscription: PropTypes.shape({
    free: PropTypes.bool,
    rank: PropTypes.number,
    plan: PropTypes.string,
    planId: PropTypes.number
  })
}

export default connect(
  stateSelector,
  null,
  mergeSelector
)(GiftSubscription)
